import Card from "@mui/material/Card";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import DataTable from "examples/Tables/DataTable";
import dataTableData from "./data/dataTableData";
import { useEffect, useState } from "react";
import { RequestService } from "services/RequestService";
import MDButton from "components/MDButton";
import MDSnackbar from "components/MDSnackbar";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { useLocation, useNavigate } from "react-router-dom";
import Grid from "@mui/material/Grid";
import AddIcon from "@mui/icons-material/Add";
import Icon from "@mui/material/Icon";
import MDInput from "components/MDInput";

function ClientsDataTables() {
  const navigate = useNavigate();

  const [dataTableData2, setDataTableData] = useState(dataTableData);
  const [show, setShow] = useState(false);
  const [error, setError] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);
  const [clientIdToDelete, setClientIdToDelete] = useState(null);
  const [message, setMessage] = useState("");
  const [search, setSearch] = useState("");
  const [firstSearch, setFirstSearch] = useState(false);

  const [pagination, setPagination] = useState({
    page: 1,
    pageSize: 10,
    totalItems: 0
  });

  const [loading, setLoading] = useState(true); 

  const toggleSnackbar = () => setShow(!show);
  const toggleSnackbar2 = () => setError(!error);

  const handleOpenDialog = (id) => {
    setClientIdToDelete(id);
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
    setClientIdToDelete(null);
  };

  const handleConfirmDelete = async () => {
    if (clientIdToDelete) {
      const result = await RequestService.delete(`client/${clientIdToDelete}`)
        .then((response) => {
          if (response.status === 200) {
            setMessage(response.data.message);
            toggleSnackbar();
            fetchClients(); // Refresh data after successful deletion
          } else {
            toggleSnackbar2();
          }
        })
        .catch((errorrs) => {
          try {
            setMessage(errorrs.response.data.message);
            toggleSnackbar2();
          } catch (error) {
            setMessage("");
            toggleSnackbar2();
          }
        });

      handleCloseDialog();
    }
  };

  const fetchClients = async () => {
    try {
      setLoading(true);
      const skip = (pagination.page - 1) * pagination.pageSize;
      const take = pagination.pageSize;

      const response = await RequestService.get(`client?searchTerm=${search}&skip=${skip}&take=${take}`);
      if (response.data.error === false) {
        const clientData = response.data.data.map((r, index) => {
          r.actions = (
            <MDBox display="flex" alignItems="center" gap={1}>
              <MDButton
                variant="gradient"
                color="info"
                size="small"
                onClick={() => {
                  navigate(`/projects/client/edit?id=${r.id}`);
                }}
                startIcon={<Icon>edit</Icon>}
              >
                تعديل
              </MDButton>
              <MDButton
                variant="outlined"
                color="error"
                size="small"
                onClick={() => handleOpenDialog(r.id)}
                startIcon={<Icon>delete</Icon>}
              >
                حذف
              </MDButton>

            </MDBox>
          );
          r["#"] = index + 1 + (pagination.page - 1) * pagination.pageSize;
          return r;
        });

        setDataTableData((prevState) => ({
          ...prevState,
          rows: clientData,
        }));
        setPagination({
          ...pagination,
          totalItems: response.data.totalCount
        });
      }
    } catch (error) {
      console.error("Error fetching clients:", error);
    } finally {
      setLoading(false);
    }
  };

  const handlePageChange = (newPage) => {
    setPagination({ ...pagination, page: newPage });
  };

  const handlePageSizeChange = (newSize) => {
    setPagination({ page: 1, pageSize: newSize, totalItems: pagination.totalItems });
  };


  useEffect(() => {
    fetchClients();
  }, [pagination.page, pagination.pageSize]);

  useEffect(() => {
    if (search || firstSearch) {
      setFirstSearch(true); {
        setPagination(prev => ({ ...prev, page: 1 }));
        const timer = setTimeout(() => {
          fetchClients();
        }, 1000);
        return () => clearTimeout(timer);
      }
    }
  }, [search]);

  return (
    <DashboardLayout>
      <MDSnackbar
        color="success"
        icon="notifications"
        title="تم اتمام العملية"
        content="تم اتمام العملية بنجاح"
        dateTime=" منذ 0 ثانية"
        open={show}
        close={toggleSnackbar}
      />

      <MDSnackbar
        color="error"
        icon="notifications"
        title="اضافة عميل"
        content="حدث خطأ ما"
        dateTime=" منذ 0 ثانية"
        open={error}
        close={toggleSnackbar2}
      />
      <DashboardNavbar />
      <MDBox pt={6} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              <MDBox
                display="flex"
                justifyContent="space-between"
                alignItems="center"
                p={3}
                sx={{
                  backgroundColor: "grey.100",
                  borderBottom: "1px solid",
                  borderColor: "grey.300",
                }}
              >
                <MDBox>
                  <MDTypography variant="h6" fontWeight="medium">
                    قائمة العملاء
                  </MDTypography>
                  <MDTypography variant="button" color="text">
                    إدارة العملاء
                  </MDTypography>
                </MDBox>
                <MDBox width="14rem" ml="auto">
                  <MDInput
                    placeholder="بحث ..."
                    value={search}
                    fullWidth
                    onChange={({ currentTarget }) => {
                      setSearch(currentTarget.value);
                    }}
                    sx={{ margin: "0 -10px" }}
                  />
                </MDBox>
                <MDButton
                  variant="gradient"
                  color="info"
                  onClick={() => {
                    navigate("/pages/projects/clients/add");
                  }}
                  startIcon={<AddIcon />}
                >
                  إضافة عميل
                </MDButton>
              </MDBox>
              <MDBox pt={3}>
                <DataTable
                  table={dataTableData2}
                  isSorted={true}
                  entriesPerPage={{
                    defaultValue: pagination.pageSize,
                    entries: [5, 10, 15, 20, 25],
                    onChange: handlePageSizeChange
                  }}
                  showTotalEntries={true}
                  noEndBorder
                  loading={loading}
                  pagination={{
                    variant: "gradient",
                    color: "info",
                    page: pagination.page,
                    totalPages: Math.ceil(pagination.totalItems / pagination.pageSize),
                    totalItems: pagination.totalItems,
                    onPageChange: handlePageChange
                  }}
                />
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
      <Footer />

      <Dialog
        open={openDialog}
        onClose={handleCloseDialog}
        aria-labelledby="confirm-delete-dialog-title"
      >
        <DialogTitle id="confirm-delete-dialog-title">تأكيد الحذف</DialogTitle>
        <DialogContent>
          <DialogContentText>سيتم حذف بيانات هذا الحقل بشكل نهائي. هل أنت متأكد؟</DialogContentText>
        </DialogContent>
        <DialogActions>
          <MDButton onClick={handleConfirmDelete} color="error">
            نعم
          </MDButton>
          <MDButton onClick={handleCloseDialog} color="secondary">
            لا
          </MDButton>
        </DialogActions>
      </Dialog>
    </DashboardLayout>
  );
}

export default ClientsDataTables;
